import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const SupplierContext = createContext(null);
const LS_KEY = "pocontrol_supplier_buyer_org";

export function SupplierProvider({ children }) {
  const [buyers, setBuyers] = useState([]);
  const [company, setCompany] = useState("");
  const [selected, setSelectedState] = useState(() => localStorage.getItem(LS_KEY) || "");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/supplier/buyers")
      .then((r) => {
        setBuyers(r.data.buyers);
        setCompany(r.data.supplier_company);
        setLoaded(true);
      })
      .catch(() => setLoaded(true));
  }, []);

  const setSelected = (orgId) => {
    localStorage.setItem(LS_KEY, orgId);
    setSelectedState(orgId);
  };

  const value = useMemo(() => {
    const validIds = buyers.map((b) => b.org_id);
    const active = selected && (selected === "all" || validIds.includes(selected))
      ? selected
      : (buyers[0]?.org_id || "all");
    const activeBuyer = buyers.find((b) => b.org_id === active) || null;
    return { buyers, company, activeBuyer, selected: active, setSelected, loaded, isAll: active === "all" };
  }, [buyers, company, selected, loaded]);

  return <SupplierContext.Provider value={value}>{children}</SupplierContext.Provider>;
}

export const useSupplier = () => useContext(SupplierContext);
